import {
  PageCoco,
  PageConfiguration,
  PageContentLibrary,
  PageCocoProfileUpdate,
  PageCocoRemoteConsent,
  PageIdentityManagement,
} from "./controls";
import { COCO_ROLE, CONFIG_READER_ROLE } from "./constants";

export const ROLE_CONFIG = {
  [COCO_ROLE]: {
    startPage: PageCoco,
    allowedPages: [PageCoco, PageCocoRemoteConsent, PageCocoProfileUpdate],
  },
  [CONFIG_READER_ROLE]: {
    startPage: PageConfiguration,
    allowedPages: [PageConfiguration, PageContentLibrary],
  },
  default: {
    startPage: PageIdentityManagement,
    allowedPages: [],
  },
};
